export default {
	inscrivezVous: 'Inscrivez-vous',
	withCodeDeblocage: 'Inscrivez-vous avec votre code de déblocage',
	descriptionCodeDeblocage: 'Si vous avez reçu un code de déblocage par courrier, suite à votre demande, vous pouvez l’utiliser pour effectuer votre première connexion. Un délai de 10 jours minimum est requis pour l’envoi du code.',
	sInscrire: 'S\'inscrire avec mon code {deblocage}',
	notification: 'Vous souhaitez faire une demande de code de déblocage ou ne l’avez pas reçu ? Appeler le',
	dejaInscrit: 'Vous avez déjà réalisé votre inscription en ligne ?'
};
